// @ts-ignore
/* eslint-disable */
import appConfig from "@/appConfig";
import { LocalStorage } from "@/utils/webStorage";
import { request } from "@umijs/max";
import qs from "qs";
const apiBaseUrl: any = appConfig?.apiBaseURL;
/** 获取当前的用户 GET /api/currentUser */
export async function queryUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>(appConfig?.adminBaseURL + "/users/me", {
    method: "GET",
    ...(options || {}),
  });
}
/** 获取当前的用户权限 */
export async function queryPermissions(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>(appConfig?.adminBaseURL + "/users/me/permissions", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取当前的用户权限 */
export async function getAllLocales(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>(appConfig?.baseDomain + "/i18n/locales", {
    method: "GET",
    ...(options || {}),
  });
}
export async function getContentManagerInit(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>(appConfig?.baseDomain + "/content-manager/init", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取chatData*/
export async function getAdminChatUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>(apiBaseUrl + "/authApi?url=/global/getSystemAgoraToken", {
    method: "POST",
    data: {},
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>(appConfig?.adminBaseURL + "/logout", {
    method: "POST",
    ...(options || {}),
  }).then((res: any) => {
    if (res.success) {
      LocalStorage.remove("jwtToken");
    }
    return res;
  });
}

/** 登录接口 POST /api/login/account */
export async function login(
  body: API.LoginParams,
  options?: { [key: string]: any }
) {
  return request<API.LoginResult>(appConfig?.adminBaseURL + "/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>("/api/notices", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any }
) {
  return request<API.RuleList>("/api/rule", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>("/api/rule", {
    method: "POST",
    data: {
      method: "update",
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>("/api/rule", {
    method: "POST",
    data: {
      method: "post",
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>("/api/rule", {
    method: "POST",
    data: {
      method: "delete",
      ...(options || {}),
    },
  });
}
/** 获取系统用户列表 */
export async function getSysUserList(body?: any) {
  return request(apiBaseUrl + "/authApi?url=/user/list", {
    method: "POST",
    data: body || {},
  });
}
/** 获取所有支付列表 */
export async function getAllPayments(body?: any) {
  return request(apiBaseUrl + "/getAllPayments", {
    method: "POST",
    data: body || {},
  });
}
// getModelOptions
export async function getModelOptions(body: any) {
  return request(apiBaseUrl + "/getModelOptions", {
    method: "POST",
    data: body,
  });
}


/** getRelations - 获取关联数据 */
export async function getRelations(query: any, body?: any) {
  const querys = [query?.documentId, query?.field].filter((val) => val);
  let url: any = `${
    appConfig?.baseDomain
  }/content-manager/relations/api::deposit-bonus.deposit-bonus/${querys.join(
    "/"
  )}`;
  if (Object.keys(body || {})?.length) url += "?" + qs.stringify(body);
  return request(url, {
    method: "GET",
  });
}
